/**
 * Contract mappers(DTO ↔ camelCase domain;R106 / docs/65)
 * -----------------------------------------------------------------------------
 * 邊界 normalize:list `?? []`、nullable `?? null`、note `?? ''`(對齊 R41.0 防漂值)。
 * request → DTO:只送有值的欄位(undefined skip;`endsAt: null` 是「無限期」明確值,保留)。
 */

import type {
  ContractDto,
  ContractSeatDto,
  CreateContractRequestDto,
  ListContractsResponseDto,
  SeatMutationRequestDto,
  UpdateContractRequestDto,
} from './contract.dtos';
import type {
  Contract,
  ContractSeat,
  CreateContractRequest,
  SeatMutationRequest,
  UpdateContractRequest,
} from './contract.types';

export function mapContractSeatDto(dto: ContractSeatDto): ContractSeat {
  return { slotIndex: dto.slot_index, email: dto.email, state: dto.state };
}

export function mapContractDto(dto: ContractDto): Contract {
  return {
    systemId: dto.system_id,
    name: dto.name,
    ownerEmail: dto.owner_email,
    ownerUid: dto.owner_uid ?? null,
    planTier: dto.plan_tier,
    seatLimit: dto.seat_limit,
    seatsUsed: dto.seats_used,
    status: dto.status,
    startDate: dto.start_date,
    renewalIntervalDays: dto.renewal_interval_days,
    endsAt: dto.ends_at ?? null,
    nextRenewalAt: dto.next_renewal_at ?? null,
    cycleSeq: dto.cycle_seq,
    resolvedGroupId: dto.resolved_group_id ?? null,
    seats: (dto.seats ?? []).map(mapContractSeatDto),
    note: dto.note ?? '',
  };
}

export function mapListContractsResponseDto(dto: ListContractsResponseDto): Contract[] {
  return (dto.contracts ?? []).map(mapContractDto);
}

export function createContractRequestToDto(req: CreateContractRequest): CreateContractRequestDto {
  const dto: CreateContractRequestDto = {
    name: req.name,
    owner_email: req.ownerEmail,
    plan_tier: req.planTier,
    seat_limit: req.seatLimit,
    start_date: req.startDate,
    status: req.status,
  };
  if (req.renewalIntervalDays !== undefined) dto.renewal_interval_days = req.renewalIntervalDays;
  if (req.endsAt !== undefined) dto.ends_at = req.endsAt;
  if (req.memberEmails !== undefined) dto.member_emails = req.memberEmails;
  if (req.note !== undefined) dto.note = req.note;
  return dto;
}

export function updateContractRequestToDto(req: UpdateContractRequest): UpdateContractRequestDto {
  const dto: UpdateContractRequestDto = {};
  if (req.name !== undefined) dto.name = req.name;
  if (req.ownerEmail !== undefined) dto.owner_email = req.ownerEmail;
  if (req.planTier !== undefined) dto.plan_tier = req.planTier;
  if (req.seatLimit !== undefined) dto.seat_limit = req.seatLimit;
  if (req.status !== undefined) dto.status = req.status;
  if (req.startDate !== undefined) dto.start_date = req.startDate;
  if (req.renewalIntervalDays !== undefined) dto.renewal_interval_days = req.renewalIntervalDays;
  if (req.endsAt !== undefined) dto.ends_at = req.endsAt;
  if (req.note !== undefined) dto.note = req.note;
  return dto;
}

export function seatMutationRequestToDto(req: SeatMutationRequest): SeatMutationRequestDto {
  return { email: req.email };
}
